import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'mlp-ng-headline',
    templateUrl: './headline.component.html',
    styleUrls: ['./headline.component.scss']
})

export class HeadlineSharedComponent {
    @Input() backgroundUrl = '/assets/img/background_image_football.jpg';
}
